import React, { useEffect, useRef, useState } from 'react';
import { Paper, Checkbox } from '@material-ui/core';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { setGlobalLoading } from 'store/global/reducer';
import styled from 'styled-components';
import api from 'api/call';
import useDialog from 'components/ConfirmDialog/useDialog';
import { GET_MEETING_ARRANGEMENT_FORM_DETAIL } from 'store/key';
import TextFieldContainer from './components/TextFieldContainer';
import PanelMemberComposition from './components/PanelMemberComposition';
import AddPanelMemberDialog from './AddPanelMemberDialog';
import TextHeader from 'components/CustomText/TextHeader';

const SHeaderLayout = styled.div`
    height: 55px;
    display: flex;
    padding: 0px 15px;
    align-items: center;
    background: #ecebf3;
    overflow: 'hidden';
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
`;

const SLayout = styled.div`
    padding: 10px;
    position: absolute;
    left: 0px;
    right: 0px;
    top: ${(props) => props.positionTop}px;
    overflow: auto;
    bottom: 5px;
`;

// applicationDetail = {} means team member form is creating without previous data
const MeetingArrangement = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const showDialog = useDialog();
    const meetingCase = props.meetingCase;
    const [saveData, setSaveData] = useState({
        applicationList: [],
        panelMemberList: [],

        notSendNotification: false,
        typeOfReview: null,
        reviewDueDate: null,
        reviewMeetingDate: null,
        reviewCirculationDate: null,
    });
    const [caseSelection, setCaseSelection] = useState(0);
    const [forceErrorDisplay, setForceErrorDisplay] = useState(false);

    useEffect(() => {
        let id = meetingCase[caseSelection];
        if (id) {
            dispatch({
                type: GET_MEETING_ARRANGEMENT_FORM_DETAIL,
                payload: {
                    params: { id },
                    callback: (res) => {
                        setSaveData({
                            ...saveData,
                            ...res,
                            applicationList: res?.meetingArrangementFormDocument || [],
                            panelMemberList: res?.meetingArrangementFormMember || [],
                            meetingCase: meetingCase,
                            caseSelection: caseSelection,
                        });
                    },
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [caseSelection]);

    // const isEditMode = id === undefined;
    const isEditMode = false;
    const handleConfirm = () => {
        if (saveData.typeOfReview === null) {
            setForceErrorDisplay(true);
            return;
        }

        let data = { ...saveData, meetingArrangementDocument: [], meetingArrangementMember: [] };
        delete data.applicationList;
        delete data.panelMemberList;
        data.meetingArrangementDocument = saveData.applicationList.reduce(
            (group, curP) =>
                group.concat({
                    documentType: curP.documentType,
                    documentId: curP.documentId,
                    refNo: curP.refNo,
                    confirmedDate: curP.confirmDate,
                }),
            [],
        );
        saveData.panelMemberList.forEach((ele) => {
            data.meetingArrangementMember.push({
                userId: ele.id,
                // isChairman: ele.chairman || false,
                panelId: ele?.list?.reduce((group, curP) => group.concat(curP.id), []) || [],
            });
        });
        if (data.meetingArrangementDocument.length === 0) {
            showDialog({
                description: NO_APPLICATION_DATA,
                disableCancelButton: true,
            });
            return;
        }
        // if (
        //     data.meetingArrangementMember.length > 0 &&
        //     !data.meetingArrangementMember.find((item) => item.isChairman)
        // ) {
        //     showDialog({
        //         description: NO_CHAIRMAN,
        //         disableCancelButton: true,
        //     });
        //     return;
        // }
        // console.log(data)
        dispatch({
            type: ADD_MEETING_ARRANGEMENT_FORM,
            payload: {
                data,
                callback: () => {
                    showDialog({
                        description: CREATED_ARRANGE_MEETING,
                        disableCancelButton: true,
                    });
                    history.goBack();
                },
            },
        });
    };
    const reset = () => {
        setSaveData({
            applicationList: [],
            panelMemberList: [],
            notSendNotification: false,
            typeOfReview: null,
            reviewDueDate: null,
            reviewMeetingDate: null,
            reviewCirculationDate: null,
        });
    };
    const handleSave = (data) => {
        setSaveData({ ...saveData, ...data });
    };

    return (
        <Paper>
            <div style={{ padding: 15, paddingBottom: 15 }}>
                <TextHeader underline>Meeting Arrangement</TextHeader>
                <div style={{ marginTop: 20 }}>
                    <div>
                        {/* <div style={{ marginTop: 30 }}> */}
                        <TextFieldContainer
                            isEditMode={isEditMode}
                            handleSave={handleSave}
                            saveData={saveData}
                            forceErrorDisplay={forceErrorDisplay}
                            setCaseSelection={(value) => setCaseSelection(value)}
                        />
                    </div>
                    <div style={{ marginTop: 30 }}>
                        <AddPanelMemberDialog
                            isEditMode={isEditMode}
                            handleSave={handleSave}
                            panelMemberList={saveData.panelMemberList}
                        />

                        <div style={{ display: 'flex', alignItems: 'center', marginTop: 15 }}>
                            <div>
                                <Checkbox
                                    color="primary"
                                    checked={saveData.notSendNotification}
                                    style={{ padding: 0 }}
                                    onChange={(e) =>
                                        setSaveData({ ...saveData, notSendNotification: e.target.checked })
                                    }
                                    disabled={!isEditMode}
                                />
                            </div>
                            <div style={{ marginLeft: 15, fontWeight: 'bold' }}>
                                Do not send notification and email to all reviewers
                            </div>
                        </div>
                    </div>
                    {(saveData.typeOfReview === 0 || saveData.typeOfReview === 1) && (
                        <div style={{ marginTop: 30 }}>
                            <PanelMemberComposition memberComposition={saveData.panelMemberList} />
                        </div>
                    )}
                </div>
            </div>
        </Paper>
    );
};

export default MeetingArrangement;
